import React, { useContext } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import CartContext from "../../context/CartContext";
import SearchContext from "../../context/SearchContext";
import PopupContext from "../../context/PopupContext";
import CardAddButton from "./CardAddButton";

const CardProductItem = ({ product }) => {
    const cartCtx = useContext(CartContext);
    const searchCtx = useContext(SearchContext);
    const popupCtx = useContext(PopupContext);

    const handleAddItem = () => {
        cartCtx.addItem(product, 1);
    };
    const handleRemoveItem = () => {
        cartCtx.removeItem(product.id, 1);
    };
    const handleRemoveAllItems = () => {
        cartCtx.removeItem(product.id, product.qty);
    };

    const subTotal = (product.specialprice || product.price) * product.qty;

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "flex-start",
                borderBottom: "1px solid #DFDFDF",
                pb: 2,
                pt: 0,
                px: 1,
                fontFamily: "Roboto, sans-serif",
                position: "relative",
                gap: 2,
            }}
        >
            {/* Product Image */}
            {product.image && (
                <Box
                    component="img"
                    src={product.image}
                    className="productimage"
                    alt={product.productname}
                    sx={{
                        width: 73,
                        height: 73,
                        borderRadius: 1,
                        cursor: "pointer",
                        objectFit: "cover",
                    }}
                />
            )}

            <Box sx={{ flexGrow: 1 }} className="productname">
                <Typography
                    sx={{ fontSize: "15px", fontWeight: 500 }}
                    dangerouslySetInnerHTML={{ __html: product.productname }}
                />
                <Typography sx={{ fontSize: "15px" }}>
                    ({product.qty} Items)
                </Typography>

                {/* Quantity + Price Row */}
                <Box sx={{ display: "flex", flexDirection: "column", mt: 1 }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>


                        <CardAddButton
                            qty={product.qty}
                            add={handleAddItem}
                            remove={handleRemoveItem}
                        />


                        <Typography sx={{ fontSize: "15px" }}>
                            × ₹{product.specialprice || product.price}
                        </Typography>
                    </Box>

                    <Box sx={{ textAlign: "right", mt: -6 }}>
                        <Typography sx={{ fontSize: "0.85rem" }}>
                            Total
                        </Typography>
                        <Typography
                            sx={{ fontSize: "1.1rem", fontWeight: 600, color: "#e44d26" }}
                        >
                            ₹{subTotal.toFixed(2)}
                        </Typography>
                    </Box>
                </Box>
            </Box>

            {/* Remove Icon */}
            <IconButton
                onClick={handleRemoveAllItems}
                className="int-icon"
                sx={{
                    position: "absolute",
                    right: 0,
                    p: 0,
                    color: "black",
                }}
            >
                <ClearIcon fontSize="small" />
            </IconButton>
        </Box>
    );
};

export default CardProductItem;
